/** Matches `launcher.js` init: viewport width used for animation breakpoints */
export function getViewportWidth() {
    if (typeof document === 'undefined' || typeof window === 'undefined') {
        return 1024;
    }
    return Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
}
const VALID_ANIMATIONS = new Set([
    'right-left',
    'bottom-top',
    'top-bottom',
    'left-right',
]);
/** True when a valid `ad_animation` resolves to a `data-adpx-animate` value */
export function hasAdEntranceAnimation(settings, viewportWidth) {
    return getAdpxAnimateAttribute(settings, viewportWidth) !== undefined;
}
/**
 * Port of `launcher.js` `addAnimations()` — value for `data-adpx-animate` on `#adpx_popup`.
 * Returns `undefined` when no animation should be applied (invalid or missing `ad_animation`).
 */
export function getAdpxAnimateAttribute(settings, viewportWidth) {
    const animation = settings.ad_animation?.toLowerCase() ?? null;
    if (!animation || !VALID_ANIMATIONS.has(animation)) {
        return undefined;
    }
    const position = settings.ad_position ?? 'center';
    const verticalOffsetMobile = settings.mobile_vertical_offset;
    if (viewportWidth > 769) {
        if (position === 'center' || position === null) {
            return `${animation}-forCenter`;
        }
        if (position === 'top-center' ||
            position === 'bottom-center' ||
            position === 'center' ||
            position === null) {
            return `${animation}-center`;
        }
        return animation;
    }
    if (verticalOffsetMobile === null || verticalOffsetMobile === 0) {
        return `${animation}-forCenter`;
    }
    return `${animation}-center`;
}
